/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding-left: ${scale.major(2)}px;
  padding-right: ${scale.major(2)}px;
`;
